function RegisterControlsListeners() {
    ///////////////////////////////
    //
    // Register different types of handlers
    //
    ///////////////////////////////
    $('.mini-cart__line-item').each(function() {

      ///////////////////////////////
      //
      // Add click handler to remove item from cart
      //
      ///////////////////////////////
      $(this).find('.product__remove').click( event => {
        event.preventDefault();
        const productId = $(this).find('.product__remove').data('productid');

        // Remove html-element visually
        $(this).remove();
        
        jQuery.post(window.Shopify.routes.root + 'cart/update.js', {
          updates: {
            [productId]: 0
          }
        }).done(function() {
          jQuery.getJSON('/cart.js', function(cart) {
            // Updated cart-icon count badge
            $('.cart-link__count').html(cart.item_count);

            if (cart.item_count == 0) {
              $('#mini-cart').slideUp();
              $("#mini-cart").toggleClass('cart-empty');
            } else {
              updateCartTotal(cart);
            }

          });
        });
        
      });

      // Hover animation for remove-item btn.
      /*$('.remove_text').hide();
      $('.remove_icon, .remove_text').hover(function(event){
        console.log("target", evt.target);
            $(event.target).next().show();
        }, function(){
            $(event.target).next().hide();
      });*/

      ///////////////////////////////
      // Update quantity ajax
      ///////////////////////////////

      ///////////////////////////////
      //
      // Add click handler for substraction
      //
      ///////////////////////////////
      $(this).find('.qty-substract').click( event => {
        const qtyInput = $(this).find('.qty-input');
        if (qtyInput.val() == 1) return;

        ///////////////////////////////
        // Update visually the cart
        ///////////////////////////////
        qtyInput.val(parseInt(qtyInput.val()) - 1);

        ///////////////////////////////
        // Update cart backend
        ///////////////////////////////
        const productid = qtyInput.data('productid');
        const value = qtyInput.val();
        jQuery.post(window.Shopify.routes.root + 'cart/update.js', {
          updates: {
            [productid]: value
          }
        }).done(function() {
          jQuery.getJSON('/cart.js', function(cart) {
              // Updated cart-icon count badge
              $('.cart-link__count').html(cart.item_count);

              // Updates Cart total price
              updateCartTotal(cart);
          });
        });
      });
    
      ///////////////////////////////
      //
      // Add click handler for addition
      //
      ///////////////////////////////
      $(this).find('.qty-add').click( event => {
        const qtyInput = $(this).find('.qty-input');
        
        ///////////////////////////////
        // Update visually the cart
        ///////////////////////////////
        qtyInput.val(parseInt(qtyInput.val()) + 1);

        ///////////////////////////////
        // Update cart backend
        ///////////////////////////////
        const productid = qtyInput.data('productid');
        const value = qtyInput.val();
        jQuery.post(window.Shopify.routes.root + 'cart/update.js', {
          updates: {
            [productid]: value
          }
        });

        jQuery.getJSON('/cart.js', function(cart) {
            $('.cart-link__count').html(cart.item_count);
        }).done(function() {
          jQuery.getJSON('/cart.js', function(cart) {
              $('.cart-link__count').html(cart.item_count);
              // Updates Cart total price
              updateCartTotal(cart);
          });
        });
      });

      ///////////////////////////////
      //
      // Add change handler for quantity
      //
      ///////////////////////////////
      $(this).find('.qty-input').click( event => {
        const qtyInput = $(this);
        
        ///////////////////////////////
        // Update visually the cart
        ///////////////////////////////
        qtyInput.val(parseInt(qtyInput.val()) + 1);

        ///////////////////////////////
        // Update cart backend
        ///////////////////////////////
        const productid = qtyInput.data('productid');
        const value = qtyInput.val();
        jQuery.post(window.Shopify.routes.root + 'cart/update.js', {
          updates: {
            [productid]: value
          }
        });

        jQuery.getJSON('/cart.js', function(cart) {
            $('.cart-link__count').html(cart.item_count);
        }).done(function() {
          jQuery.getJSON('/cart.js', function(cart) {
              $('.cart-link__count').html(cart.item_count);
              // Updates Cart total price
              updateCartTotal(cart);
          });
        });
      });
      
  });
}

function flyToElement(flyer, flyingTo, addToCartBtn, cart) {
  
    // Replace elements in cart
    let newItemHTML = "";
    cart.items.forEach( (product, index) => {
      let attributes = "";

      if (index == 0) {
        attributes = 'style="margin-left: -100%; opacity: 0;"';
      }
      
      newItemHTML += `
      <div class="mini-cart__line-item" data-variant-id="${product.id}" ${attributes}>
          <img width="90px" src="${product.image}?width=90" alt="${product.title}" />
          <div class="product-details">
            <p class="product__vendor">${product.vendor}</p>
            <a href="${product.url}" class="product__title">${product.title}</a>
            <div class="product__actions">
              <div class="product__quantity">
                    <input class="btn qty-substract" type="button"  value="-" />
                    <input class="qty qty-input" data-productid="${product.id}" type="text" name="updates[]" value="${product.quantity}" disabled />
                    <input class="btn qty-add" type="button"  value="+" />
              </div>
              <div class="pricing-wrapper">
                <p class="product__price"><span class="currency">DKK</span>${convertCurrencyDKK(product.price)}</p>
              </div>
              <a class="product__remove" href="/cart/change?id=${product.key}&quantity=0" data-productid="${product.id}">
                <img class="remove_icon" height="15px" width="15px" src="https://cdn.shopify.com/s/files/1/0561/3538/5224/t/4/assets/cancel.png?v=176586223072541475381661256353" alt="Fjern produkt fra kurven" />
              </a>
            </div>
          </div>
      </div>
      `;
    } );
    
    // Append the new item to DOM
    $('.mini-cart-line-items').html(newItemHTML);

    // Register lsiteners for new element generated by the javascript
    RegisterControlsListeners();
  
    // Update total in cart.
    updateCartTotal(cart);
  
    // Animation
    var $func = $(this);
    var divider = 20;
    var flyerClone = $(flyer).clone();

    var animationSpeed = 1200;

    // Cloning product image - MOBILE
    if (screen.width < 768) {
      $(flyerClone).css({
        position: 'absolute', 
        top: $(flyer).offset().top + "px", 
        left: $(flyer).offset().left + "px", 
        opacity: 1, 
        'z-index': 9999, 
        'border-radius': '100%', 
        height: "200px",
        width: "200px",
        border: "20px solid #fff" 
      });
      
      
      animationSpeed = 900; // As it's a smaller screen, we need the animation to be faster.
    }

    // Cloning product image - DESKTOP
    if (screen.width >= 768) {
      $(flyerClone).css({
        position: 'absolute', 
        top: $(flyer).offset().top + "px", 
        left: $(flyer).offset().left + "px", 
        opacity: 1, 
        'z-index': 5000, 
        'border-radius': '100%', 
        height: "700px",
        width: "700px",
        border: "20px solid #fff" 
      });
    }

    $('body').append($(flyerClone));
    var gotoX = $(flyingTo).offset().left + ($(flyingTo).width() / 2) - ($(flyer).width()/divider)/2;
    var gotoY = $(flyingTo).offset().top + ($(flyingTo).height() / 2) - ($(flyer).height()/divider)/2;
     
    $(flyerClone).animate({
        opacity: 1,
        left: gotoX,
        top: gotoY,
        width: $(flyer).width()/divider,
        height: $(flyer).height()/divider,
        "border-width": 0
    }, animationSpeed,
    function () {
        $(flyingTo).fadeOut('fast', function () {
            $(flyingTo).fadeIn('fast', function () {
                $(flyerClone).fadeOut('1000', function () {
                    // Using default speed: 400
                    $('#mini-cart').slideDown(400, function() {
                      // Enable button again
                      addToCartBtn.prop('disabled', false);
                      // Delete clone
                      $(flyerClone).remove();
                      // Slide new element in
                      $('.mini-cart__line-item:first-child').animate({'margin-left': '+=100%', 'opacity': '+=1'}, 1100);
                    });
                });
            });
        });
    });
}

function convertCurrencyDKK(price) {
  // Convert currency to DKK
   var priceString = price.toString();
    var priceLength = priceString.length;
    var addedComma = priceString.substring(0, priceLength-2) + "." + priceString.substring(priceLength-2);
    const totalPrice = new Intl.NumberFormat('da-DK', { style: 'currency', currency: 'DKK' }).format(addedComma.replace(" kr", ",-"));
  return totalPrice.replace("&nbsp;kr.", ",-");
}

function updateCartTotal(cart) {
  // Convert currency
  const totalPrice = convertCurrencyDKK(cart.total_price);

  // Update total in cart.
    $('#mini-cart #line-total').html(totalPrice);
}

function addGiftBox(cart) {
  
    // Replace elements in cart
    let newItemHTML = "";
    cart.items.forEach( (product, index) => {
      let attributes = "";

      if (index == 0) {
        attributes = 'style="margin-left: -100%; opacity: 0;"';
      }
      
      newItemHTML += `
      <div class="mini-cart__line-item" data-variant-id="${product.id}" ${attributes}>
          <img width="90px" src="${product.image}?width=90" alt="${product.title}" />
          <div class="product-details">
            <p class="product__vendor">${product.vendor}</p>
            <a href="${product.url}" class="product__title">${product.title}</a>
            <div class="product__actions">
              <div class="product__quantity">
                    <input class="btn qty-substract" type="button"  value="-" />
                    <input class="qty qty-input" data-productid="${product.id}" type="text" name="updates[]" value="${product.quantity}" disabled />
                    <input class="btn qty-add" type="button"  value="+" />
              </div>
              <div class="pricing-wrapper">
                <p class="product__price"><span class="currency">DKK</span>${convertCurrencyDKK(product.price)}</p>
              </div>
              <a class="product__remove" href="/cart/change?id=${product.key}&quantity=0" data-productid="${product.id}">
                <img class="remove_icon" height="15px" width="15px" src="https://cdn.shopify.com/s/files/1/0561/3538/5224/t/4/assets/cancel.png?v=176586223072541475381661256353" alt="Fjern produkt fra kurven" />
              </a>
            </div>
          </div>
      </div>
      `;
    } );
    
    // Append the new item to DOM
    $('.mini-cart-line-items').html(newItemHTML);

    // Register lsiteners for new element generated by the javascript
    RegisterControlsListeners();
  
    // Update total in cart.
    updateCartTotal(cart);
  
    // Animation
    $('.mini-cart__line-item:first-child').animate({'margin-left': '+=100%', 'opacity': '+=1'}, 1100);
                    
}